import * as ActionTypes from '../constants/ActionTypes'

export const configurationScrollProgress = (val) => ({
    type: ActionTypes.CONFIGURATION_SCROLL_PROGRESS,
    configurationScrollProgress: val
})


export const undoStepCompletion = (stepLabel) => ({
    type: ActionTypes.STEP_UNDONE,
    stepLabel
})

export const togglePasswordVisibility = () => ({
    type: ActionTypes.FORM_TOGGLE_PASSWORD_VISIBILITY
})


/** WEBPACK FOOTER **
 ** ./src/actions/UserInterface.js
 **/